"use client";

import { c as _c } from "react/compiler-runtime";
import { useHits, useInstantSearch } from "react-instantsearch";
import { useTranslations } from "next-intl";
interface AlgoliaHit {
  objectID: string;
  title?: string;
  headline?: string;
  name?: string;
  _type?: string;
  slug?: string;
  _highlightResult?: {
    title?: {
      value?: string;
    };
    headline?: {
      value?: string;
    };
    name?: {
      value?: string;
    };
  };
}
interface SearchAutocompleteProps {
  onSelectResult: (slug: string, title: string) => void;
}

/**
 * Displays Algolia instant search results with keyword highlighting.
 * Renders as a simple list of text links.
 */
export function SearchAutocomplete(t0) {
  const $ = _c(37);
  const {
    onSelectResult
  } = t0;
  const t = useTranslations("search");
  const {
    indexUiState
  } = useInstantSearch();
  const {
    items
  } = useHits();
  const query = indexUiState.query ?? "";
  if (!query) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function getHighlightedTitleHtml(hit) {
      const highlight = hit._highlightResult;
      if (highlight?.title?.value) {
        return highlight.title.value;
      }
      if (highlight?.headline?.value) {
        return highlight.headline.value;
      }
      if (highlight?.name?.value) {
        return highlight.name.value;
      }
      return null;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const getHighlightedTitleHtml = t1;
  let t2;
  if ($[1] !== t) {
    t2 = function getPlainTitle(hit_0) {
      return hit_0.title ?? hit_0.headline ?? hit_0.name ?? t("untitled");
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getPlainTitle = t2;
  if (items.length === 0) {
    let t3;
    if ($[3] !== t) {
      t3 = t("searchResults");
      $[3] = t;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t) {
      t4 = t("searchResults");
      $[5] = t;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t4) {
      t5 = <h3 className="typography-component-xs-medium text-text-link uppercase tracking-wider mb-4">{t4}</h3>;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== query || $[10] !== t) {
      t6 = t("noResultsFoundFor", {
        query
      });
      $[9] = query;
      $[10] = t;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t6) {
      t7 = <p className="typography-component-sm-regular text-text-secondary">{t6}</p>;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t3 || $[15] !== t5 || $[16] !== t7) {
      t8 = <section aria-label={t3}>{t5}{t7}</section>;
      $[14] = t3;
      $[15] = t5;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    return t8;
  }
  let t3;
  if ($[18] !== t) {
    t3 = t("searchResults");
    $[18] = t;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== t) {
    t4 = t("searchResults");
    $[20] = t;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== t4) {
    t5 = <h3 className="typography-component-xs-medium text-text-link uppercase tracking-wider mb-4">{t4}</h3>;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== getPlainTitle || $[25] !== items || $[26] !== onSelectResult) {
    let t7;
    if ($[28] !== getPlainTitle || $[29] !== onSelectResult) {
      t7 = hit_1 => {
        const slug = hit_1.slug ?? "#";
        const highlightedTitleHtml = getHighlightedTitleHtml(hit_1);
        const plainTitle = getPlainTitle(hit_1);
        return <li key={hit_1.objectID}><button type="button" onClick={() => onSelectResult(slug, plainTitle)} className="cursor-pointer text-left typography-component-sm-medium text-text-primary hover:text-text-link-hover transition-colors [&_em]:font-bold [&_em]:not-italic">{highlightedTitleHtml ? <span dangerouslySetInnerHTML={{
              __html: highlightedTitleHtml
            }} /> : plainTitle}</button></li>;
      };
      $[28] = getPlainTitle;
      $[29] = onSelectResult;
      $[30] = t7;
    } else {
      t7 = $[30];
    }
    t6 = items.map(t7);
    $[24] = getPlainTitle;
    $[25] = items;
    $[26] = onSelectResult;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[31] !== t6) {
    t7 = <ul className="space-y-3">{t6}</ul>;
    $[31] = t6;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== t3 || $[34] !== t5 || $[35] !== t7) {
    t8 = <section aria-label={t3}>{t5}{t7}</section>;
    $[33] = t3;
    $[34] = t5;
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  return t8;
}